'use strict';

var React = require('react');

var SvgStoreMinor = function SvgStoreMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m2.554 3.128-.542 3.224a.893.893 0 0 0 .513.964c.12.055.25.084.382.084h.81a1.369 1.369 0 0 0 1.217-.747l.53-1.053.531 1.053a1.354 1.354 0 0 0 1.218.747h1.04a1.369 1.369 0 0 0 1.216-.747l.531-1.053.53 1.053a1.355 1.355 0 0 0 1.218.747h1.04a1.369 1.369 0 0 0 1.217-.747l.53-1.053.531 1.053a1.354 1.354 0 0 0 1.217.747h.81a.913.913 0 0 0 .692-.318.898.898 0 0 0 .203-.73l-.542-3.224a1.347 1.347 0 0 0-.463-.808 1.367 1.367 0 0 0-.88-.32h-12.207c-.322 0-.633.113-.88.32-.245.206-.41.492-.462.808Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 16.65v-7.65h-14v7.65c0 .358.141.701.393.955.252.253.594.395.95.395h2.673v-6h5.968v6h2.673c.356 0 .698-.142.95-.395.252-.254.393-.597.393-.955Z"
  }));
};

exports.SvgStoreMinor = SvgStoreMinor;
